export default __webpack_public_path__ + "static/feature-discovery-start-b1827fa6169bae3bb6314d74f5848e45f27ad74099f28cf6a01b4a5ac901ee00.png";